module.exports = __webpack_public_path__ + "img/logo1.d0f931f4.png";